import {orderBy, groupBy, get } from 'lodash';

const orderByCriteria = (array, path, order = 'asc') => {
  return (
    orderBy(array, item => {
      return get(item, path, '');
    }, [order])
  );
};

const groupByCriteria = (array, path, order = 'asc') => {
  return groupBy(array, item => {
    return get(item, path, '');
  }, [order]);
};

export { orderByCriteria, groupByCriteria };



// WEBPACK FOOTER //
// ./app/utils/OrderGroupByUtils.js